export default __webpack_public_path__ + "static/media/logo.e44d605c.png";